import React from "react";
import PropTypes from "prop-types";
import Spinner from "react-bootstrap/Spinner";

import Modal from "../../../Modal";
import ButtonGroup from "../../../Button/ButtonGroup";
import Button from "../../../Button";

const ConfirmationFooter = ({
  onReject,
  onConfirm,
  onClose,
  closeButtonText,
  confirmButtonText,
  confirmButtonVariant,
  closeButtonVariant,
  closeButtonDisabled,
}) => {
  const [submitting, setSubmitting] = React.useState(false);
  const onClickConfirm = React.useCallback(async () => {
    if (onConfirm) {
      setSubmitting(true);
      return Promise.resolve(onConfirm()).finally(() => {
        onClose();

        setSubmitting(false);
      });
    }
    onConfirm && onConfirm();
    onClose();
  }, [onClose, onConfirm, setSubmitting]);

  const onClickCancel = React.useCallback(() => {
    onReject && onReject();
    onClose();
  }, [onClose, onReject]);

  return (
    <Modal.Footer>
      <ButtonGroup className="modal-footer-buttons">
        <Button
          variant={closeButtonVariant}
          onClick={onClickCancel}
          disabled={submitting || closeButtonDisabled}
          className="m-0"
        >
          {closeButtonText}
        </Button>
        <Button
          onClick={!submitting && onClickConfirm}
          variant={confirmButtonVariant}
          className="m-0"
        >
          {submitting ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            confirmButtonText
          )}
        </Button>
      </ButtonGroup>
    </Modal.Footer>
  );
};

ConfirmationFooter.propTypes = {
  onConfirm: PropTypes.func,
  onReject: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  closeButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  closeButtonVariant: PropTypes.string,
  closeButtonDisabled: PropTypes.bool,
};

ConfirmationFooter.defaultProps = {
  closeButtonText: "No",
  confirmButtonText: "Yes",
  closeButtonVariant: "dark",
  confirmButtonVariant: "primary",
};

export default ConfirmationFooter;
